import React from "react";
import { Quote, Star } from "lucide-react";

const REVIEWS = [
  {
    id: "maria-g-jello",
    text: "Best $1 jell-o shots in Houston, no contest. Walter remembered our order from a month ago.",
    name: "Maria G.",
    tag: "Regular",
    stars: 5,
  },
  {
    id: "drew-p-galveston",
    text: "It's like someone took a Galveston beach bar and dropped it into downtown Houston.",
    name: "Drew P.",
    tag: "Tourist",
    stars: 5,
  },
  {
    id: "jordan-a-astros",
    text: "Stopped in before the Astros game and almost missed first pitch. Worth it.",
    name: "Jordan A.",
    tag: "Game-day",
    stars: 5,
  },
  {
    id: "sam-k-boss",
    text: "Sticky floors, neon signs, and the bartender called me boss. 10/10.",
    name: "Sam K.",
    tag: "Local",
    stars: 5,
  },
  {
    id: "lex-r-pours",
    text: "Cheapest pours downtown — and they're stronger than half the cocktail bars.",
    name: "Lex R.",
    tag: "Office crowd",
    stars: 4,
  },
  {
    id: "morales-pool-friend",
    text: "Played pool with a stranger for 3 hours. He's at my wedding now.",
    name: "T. Morales",
    tag: "Regular",
    stars: 5,
  },
];

const Stars = ({ count }) => (
  <div className="flex gap-0.5 text-[#FFB800]">
    {Array.from({ length: count }, (_, i) => `star-${i + 1}-of-${count}`).map(
      (k) => (
        <Star key={k} size={14} fill="#FFB800" strokeWidth={0} />
      ),
    )}
  </div>
);

const ReviewCard = ({ review }) => (
  <article
    data-testid={`review-card-${review.id}`}
    className="grain-card bg-[#0A0A0A] border border-[#262626] p-6 md:p-7 flex flex-col gap-4 hover:border-[#FF2A2A]/50 transition-colors"
  >
    <Quote size={28} strokeWidth={2.5} className="text-[#FF2A2A] opacity-80" />
    <p className="text-[#F5F2E6] text-base md:text-lg leading-relaxed">
      "{review.text}"
    </p>
    <div className="mt-auto pt-4 border-t border-[#262626] flex items-center justify-between">
      <div>
        <div className="font-display text-xl text-[#F5F2E6] leading-none">
          {review.name}
        </div>
        <div className="mt-1 font-mono-plex text-[10px] tracking-[0.25em] uppercase text-[#A3A3A3]">
          {review.tag}
        </div>
      </div>
      <Stars count={review.stars} />
    </div>
  </article>
);

const ReviewsHeader = () => (
  <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
    <div>
      <div className="font-mono-plex text-[11px] tracking-[0.3em] uppercase text-[#FF2A2A] flex items-center gap-3">
        <span className="h-px w-8 bg-[#FF2A2A]" /> 05 — Word on the Street
      </div>
      <h2 className="mt-4 font-display text-5xl md:text-7xl leading-[0.95] text-[#F5F2E6]">
        THE PEOPLE
        <br />
        <span className="text-[#FFB800] neon-amber">TALK.</span>
      </h2>
    </div>
    <p className="max-w-sm text-[#A3A3A3]">
      Pulled straight from the reviews that keep saying the same thing: this
      place is the real deal.
    </p>
  </div>
);

const Reviews = () => {
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="relative px-6 md:px-12 lg:px-24 py-24 md:py-32 bg-[#121212] border-y border-[#262626]"
    >
      <ReviewsHeader />
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {REVIEWS.map((r) => (
          <ReviewCard key={r.id} review={r} />
        ))}
      </div>
    </section>
  );
};

export default Reviews;
